import React from "react";

import { useTranslation } from "react-i18next";
import Group from "../../../assets/images/group.png";
import { LeftOutlined } from "@ant-design/icons";
import NAVEEN from "../../../assets/images/naveen.jpeg";
import { Typography, Button, Row, Col, Carousel } from "antd";
import SPOORTHI from "../../../assets/images/spoorthi.jpeg";
import VIJAY from "../../../assets/images/vijay.jpeg";
import MANOHARA from "../../../assets/images/manohara.jpeg";
import OrangeLine from "../../../assets/images/orange_line.png";
import SatishChandra from "../../../assets/images/image-min.png";
import GOWTHAM from "../../../assets/images/gowtham.jpeg";
const { Paragraph, Title } = Typography;
const TeamExtended = () => {
  const { t } = useTranslation("common");

  return (
    <React.Fragment>
      <div className="team_back_button">
        <Button
          size="small"
          icon={
            <span className="gradient-icon">
              <LeftOutlined />
            </span>
          }
          href="/"
        >
          <span className="gradient-text">Back</span>
        </Button>
      </div>
      <Row id="teamextended">
        <Row className="team_title">
          <div className="orange-box">
            <img src={Group} />
          </div>
          <Title className="teamTitle">
            <span className="first_word">Our</span> Team
          </Title>
          <img src={OrangeLine}></img>
        </Row>

        <Row className="team_sec">
          <Row justify="space-around" className="team_row">
            <Col xs={24} sm={24} md={6} xl={6} xxl={6}>
              <img src={SatishChandra}></img>
            </Col>
            <Col className="teamPara" xs={24} sm={24} md={24} xl={14} xxl={14}>
              <Title className="teamName" level={5}>
                Satish Chandra C S
              </Title>

              <p>Agricultural Technology & Finance</p>

              <Paragraph className="para">
                Over three decades of experience as a Valuator, Finance researcher, Mentor in Agri
                Tech.As an advisor he is mentoring us on Agri Strategy, Roadmap
                and finance
              </Paragraph>
            </Col>
          </Row>

          <Row className="teamCarouselUnit">
            <Carousel>
              <div>
                <div className="teamContainer">
                  <img src={SPOORTHI}></img>
                  <Title className="teamName" level={5}>
                    Spoorthi Kulkarni
                  </Title>
                  <p>Full Stack Developer</p>
                </div>
              </div>

              <div>
                <div className="teamContainer">
                  <img src={VIJAY}></img>
                  <Title className="teamName" level={5}>
                    Vijay Sajjanar
                  </Title>
                  <p>Frontend And Android Developer</p>
                </div>
              </div>

              <div>
                <div className="teamContainer">
                  <img src={NAVEEN}></img>
                  <Title className="teamName" level={5}>
                    Naveen
                  </Title>
                  <p>Sales & Operation</p>
                </div>
              </div>

              <div>
                <div className="teamContainer">
                  <img src={MANOHARA}></img>
                  <Title className="teamName" level={5}>
                    Manohara A.J
                  </Title>
                  <p>Sales & Operation</p>
                </div>
              </div>

              <div>
                <div className="teamContainer">
                  <img src={GOWTHAM}></img>
                  <Title className="teamName" level={5}>
                    Gowtham S
                  </Title>
                  <p>Sales & Operation</p>
                </div>
              </div>
            </Carousel>
            <p className="teamDescription">
              <strong>SamparkBindhu Team </strong>is driven by a shared vision to solve real-world challenges through technology. With strong experience across engineering, delivery, operations, and community-focused initiatives, we bring the right balance of innovation and execution. Our team believes in building impactful solutions that empower rural communities, enable sustainable growth, and create long-term value. Together, we are committed to making a meaningful difference through AgriTech and Finance.
            </p>
          </Row>
        </Row>
      </Row>
    </React.Fragment>
  );
};

export default TeamExtended;
